const mainTemplate = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>POKE-CSS</title>
    <link rel="stylesheet" href="poke-css/style/main.css">
</head>
<body>



</body>
</html>`

export default mainTemplate